<section class="header-superior" id="header">
    <div class="part1">
        <div class="component">
            <svg xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                <path
                    d="M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zm48 0c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256z" />
            </svg>
            <span (click)="showLanguages = !showLanguages">{{selectedLanguage | translate}}<span
                    *ngIf="!showLanguages">▾</span><span *ngIf="showLanguages">▴</span></span>
            <div *ngIf="showLanguages" class="dropdown" @openCloseAnimation>
                <ul>
                    <li (click)="changeLanguage(1)">
                        <div class="language">
                            <img src="assets/img/idiomas/flag-espana.png"
                                alt="{{'header-superior.idiomas.altEsp' | translate}}">
                            <span>{{'header-superior.idiomas.esp' | translate}}</span>
                        </div>
                    </li>
                    <li (click)="changeLanguage(2)">
                        <div class="language">
                            <img src="assets/img/idiomas/flag-gb.png"
                                alt="{{'header-superior.idiomas.altUK' | translate}}">
                            <span>{{'header-superior.idiomas.ingUK' | translate}}</span>
                        </div>
                    </li>
                    <li (click)="changeLanguage(3)">
                        <div class="language">
                            <img src="assets/img/idiomas/flag-usa.png"
                                alt="{{'header-superior.idiomas.altUSA' | translate}}">
                            <span>{{'header-superior.idiomas.ingUSA' | translate}}</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="part2">
        <div class="component">
            <svg xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                <path
                    d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z" />
            </svg>
            <a [href]="webUrl" target="_blank">
                {{'header-superior.viejo' | translate}}
            </a>
        </div>
    </div>
</section>